"use client";

import { useQuery } from "@tanstack/react-query";

import { getReportColumnsQueryKey, reportColumns } from "@/lib/api/generated";

export function useConversationColumns() {
  return useQuery({
    queryKey: getReportColumnsQueryKey(),
    queryFn: () => reportColumns(),
    staleTime: 60_000,
  });
}
